import React, { useMemo, useState } from 'react';
import { Box, Divider, IconButton, ListItemIcon, Menu, MenuItem, Typography } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';

/**
 * Primary row actions as icon buttons (children) plus an optional overflow menu (⋮).
 * Stops propagation so DataGrid row click does not fire.
 */
export default function ListRowActionsBar({ children, menuItems = [] }) {
  const [anchor, setAnchor] = useState(null);
  const open = Boolean(anchor);

  const items = useMemo(() => menuItems.filter(Boolean), [menuItems]);

  return (
    <Box
      sx={{ display: 'inline-flex', alignItems: 'center', gap: 0.25, flexWrap: 'nowrap' }}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
      {items.length > 0 ? (
        <>
          <IconButton
            size="small"
            aria-label="More actions"
            aria-controls={open ? 'list-row-actions-menu' : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            onClick={(e) => {
              e.stopPropagation();
              setAnchor(e.currentTarget);
            }}
          >
            <MoreVertIcon fontSize="small" />
          </IconButton>
          <Menu
            id="list-row-actions-menu"
            anchorEl={anchor}
            open={open}
            onClose={() => setAnchor(null)}
            onClick={(e) => e.stopPropagation()}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          >
            {items.map((item, idx) =>
              item.divider ? (
                <Divider key={`div-${idx}`} sx={{ my: 0.5 }} />
              ) : (
                <MenuItem
                  key={`${item.label}-${idx}`}
                  disabled={item.disabled}
                  onClick={(e) => {
                    e.stopPropagation();
                    setAnchor(null);
                    item.onClick?.();
                  }}
                >
                  {item.icon ? <ListItemIcon sx={{ minWidth: 36 }}>{item.icon}</ListItemIcon> : null}
                  <Typography variant="body2">{item.label}</Typography>
                </MenuItem>
              )
            )}
          </Menu>
        </>
      ) : null}
    </Box>
  );
}
